"use client";

const BackButton = () => {
  return (
    <button
      onClick={() => window.history.back()}
      className="text-user-primary hover:text-[#5d00c7] mt-4"
    >
      ← Go Back
    </button>
  );
};

export default BackButton;
